import React, { useEffect } from "react";
import "./App.css";
import {
  Route,
  BrowserRouter,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { PlacePage } from "./pages/PlacePage";
import { GadderingPage } from "./pages/GadderingPage";
import { VotingNavigation } from "./pages/voting/VotingNavigation";
import { SubscriptionWrapper } from "./pages/subscription/SubscriptionNavigation";
import { Dimensions, View } from "react-native";
import {CheckCodePage} from "./pages/CheckCodePage";

function AppNavigation() {
  const location = useLocation();

  const getScreens = () => {
    const startedLocation = location.pathname.split("/")[1];

    switch (startedLocation) {
      case "place":
        return (
          <Routes>
            <Route path={"/place/:placeId"} element={<PlacePage />} />
          </Routes>
        );

      case "code":
        return (
            <Routes>
              <Route path={"/code"} element={<CheckCodePage />} />
            </Routes>
        );
      case "gaddering":
        return (
          <Routes>
            <Route
              path={"/gaddering/:gadderingId"}
              element={<GadderingPage />}
            />
          </Routes>
        );
      case "app":
        return <VotingNavigation />;
      case "subscription":
        return <SubscriptionWrapper />;
      default:
        return <NotFoundNavigation />;
    }
  };

  return <>{getScreens()}</>;
}

function App() {
  return (
    <BrowserRouter>
      <AppNavigation />
    </BrowserRouter>
  );
}

const NotFoundNavigation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("../not-found", { replace: true });
  }, []);

  return (
    <Routes>
      <Route
        path="*"
        element={
          <View style={{ height: Dimensions.get("window").height }}>
            Not Found
          </View>
        }
      />
    </Routes>
  );
};

export default App;
